import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const pressKit = [
  {
    href:
      'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/lp-org.jpg',
  },
  {
    href:
      'https://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/businessworld.jpg',
  },
  {
    href: 'https://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/woldbank.jpg',
  },
  {
    href: 'https://www.slush.org/company/honeyguide-apps/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/slush.jpg',
  },
  {
    href: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/besthike.jpg',
  },
  {
    href: 'http://nepalitimes.com/article/Nepali-Times-Buzz/honeyguide-apps-review,2644',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/nepal-times.jpg',
  },
  {
    href: 'https://thehimalayantimes.com/mobile-apps/honey-guide-travel-app/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/himalayan-times.jpg',
  },
  {
    href:
      'http://e.myrepublica.com/component/flippingbook/book/2107-republica-24-dec-2015/1-republica.html',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/republica.jpg',
  },
  {
    href:
      'http://kathmandupost.ekantipur.com/news/2016-06-26/honeyguide-to-launch-trekking-in-nepal-app.html',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/kathmandu-post.jpg',
  },
  {
    href: 'http://www.newbusinessage.com/MagazineArticles/view/1960',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/new-business-age2.jpg',
  },
  {
    href: 'http://annapurnapost.com/EpaperDetails.aspx/paper/6334',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/annapurna-post.jpg',
  },
  {
    href: 'http://kantipur.ekantipur.com/printedition/news/2016-06-24/20160624113957.html',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/kantipur.jpg',
  },
];
const Press = () => (
  <Page {...seo.press}>
    <h2 className="mt-0 pt-0">PRESS</h2>
    <img src="https://s3.amazonaws.com/honeyguide/assets/everest-top.jpg" alt="Everest" />

    <p className="mt-3 mb-1">Hi,</p>
    <p>At HoneyGuide we are driven by a lust for mountains and the urgency to:</p>
    <ol>
      <li>
        <strong>Introduce Transparency in Nepal’s Adventure Travel Industry</strong>
        <p>
          through information so actionable that anyone will be confident to hit the trails
          on their own. We believe that travel companies should not and need not depend upon
          fear and ignorance to sell tours.
        </p>
      </li>
      <li>
        <strong>Put Trekkers in Charge of their Treks</strong>
        <p>
          by providing them with tools to run their treks the way they see fit. We believe
          putting the power back in the hands of the trekker will not only make our trails
          safer, but also give more people the confidence to undertake a trek in the
          Himalayas.
        </p>
      </li>
      <li>
        <strong>Empower Local Service Providers</strong>
        <p>
          like Lodges, Guides, and Porters by giving them direct access to trekkers. This we
          hope will not only result in an equitable distribution of tourism dividends, but
          will also increase service level faster as now kickbacks and discounts will not be
          the factors that will bring in business.
        </p>
      </li>
    </ol>
    <p>For the work we have done, we have received positive reviews from many places</p>
    <div className="row my-4">
      {pressKit.map(v => (
        <div
          key={v.href}
          className="col-6 col-sm-4 col-md-3 mt-3 mt-md-0 mb-3"
          style={{ overflow: 'hidden' }}
        >
          <a href={v.href} target="_blank" rel="noopener noreferrer nofollow">
            <img src={v.imgSrc} alt={v.imgSrc} />
          </a>
        </div>
      ))}
    </div>
    <p>
      If you are looking for insights, stories, leads, or contacts in the Himalayas, please
      free to contact us.
    </p>
    <p>
      Contact: <br />
      Ashish Shrestha, CEO, HoneyGuide. <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">
        honeyhunter@honeyguideapps.com
      </a>{' '}
      <br />
      +977-9841370673
    </p>
    <h2>EMPOWERING THE HIMALAYAS | FEB-2-2019 | PRESS RELEASE</h2>
    <p>
      <p>
        <strong>FOR IMMEDIATE RELEASE</strong> <br />2 February 2019
      </p>
      <h5>HONEYGUIDE YOUR WAY TO EVEREST</h5>
      <p>HoneyGuide launches a new way to trek to Everest Base Camp.</p>
      <p>
        Kathmandu, Nepal. To cater to a new generation of trekkers who are used to booking
        everything online, HoneyGuide has introduced a system which helps trekkers book
        flights, lodges, guides, and even porters online. The system brings together around
        86 lodges, 26 trekking guides, and 1 airline into an integrated booking system.
      </p>
      <p>
        The idea is to give trekkers the confidence to undertake a trek on their own while
        maintaining complete control over their trek. The founders of this system hope that
        putting trekkers in charge of their treks will help them get the most out of their
        trek.
      </p>
      <p>
        “Transparency is at the heart of what we do,” says Ashish Shrestha, one of the three
        Co-Founders of HoneyGuide. “We believe in providing no-strings-attached information
        so that the trekkers can decide on how best to run their trek. So while trekkers are
        booking the Everest Base Camp Trek in HoneyGuide, they can either book the whole
        trek, just flights, a few lodges, or a guide, that is their call. HoneyGuide makes
        all of that possible easily. We even provide trekkers with contact details of lodges
        and guides so that trekkers can book them directly if they wish to.”
      </p>
      <p>
        Based on the fact that HoneyGuide’s “Trekking in Nepal” mobile app has been used by
        over 20,000 trekkers, it can be reasonably inferred that providing trekkers with
        high-quality information is a must at this age.
      </p>
      <p>
        Abhishek, another co-founder with experience in managing adventure sports events
        like the Everest Marathon, however, thinks that there is more to the story than just
        information. “Information might be a part of the story, but personalization is more
        important. People are used to things bending around their needs, and they want
        things to happen exactly when and how they want it. For example 15 years ago,
        everybody would buy international flights and hotels in Kathmandu from trekking
        companies. Now that number is effectively zero. If anyone wishes to do well in the
        travel industry, they have to give exactly what the trekkers want at their
        convenience.”
      </p>
      <p>
        Indeed HoneyGuide’s new online system allows trekkers to select the lodges they want
        as they plan their <a href="https://goo.gl/FKaBru">Everest Base Camp Trek</a>,
        select the guides they wish to take, and book them at their preferred dates. “We
        have worked very hard to make customizing and booking a trek as easy as buying a
        travel package.”, says Diwaker Ghimire, CTO and Co-founder.
      </p>
      <p>
        “However, it is people that have made HoneyGuide work,” says Dakshina Khadka, who
        oversees Communications at HoneyGuide. She adds, “The best part of building this new
        system, was the support we got from everyone in Everest. More than the technology I
        feel that HoneyGuide is a reflection of the trust that lodge owners and guides have
        put in a system that will hopefully bring a measure of transparency and community
        empowerment in Nepal’s trekking industry.”
      </p>
      <p>
        Indeed online systems like HoneyGuide have been known to help the service providers
        in the travel industry get their fair share of tourism dividends. For example with
        Airbnb, there are millions of people in the world who have benefited directly from
        the travel industry. Also, noteworthy is the fact that online booking platforms like
        Expedia and Booking.com were instrumental in the rise of smaller boutique hotels
        around the world.
      </p>
      <p>
        Asked what is next for HoneyGuide, Ashish says that, “Similar issues exist not just
        in Everest, but the Annapurna, Langtang, Manaslu and even in Ladakh and Himachal
        regions. Wherever there are mountains, HoneyGuide will be there. However, for the
        next few months, we will focus all of our effort on working with Service Providers,
        Destination Marketing Organizations, Non-Residential Nepalese and even Travel
        Companies to promote Nepal more creatively. More information can be found at
        HoneyGuide's website.”
      </p>
      <p>
        <strong>About HoneyGuide</strong>|{' '}
        <a href="https://honeyguideapps.com/p/about-us">
          https://honeyguideapps.com/p/about-us
        </a>
      </p>
      <p>
        HoneyGuide is a technology company based in Kathmandu that makes sure that men and
        mountains meet more often by providing trekkers with quality information, and
        capacity to book guides, flights, lodges, and porters in the Everest Region.
      </p>
      <p style={{ textAlign: 'center' }}>
        <strong>###</strong>
      </p>
      <p>
        <strong>Press Kit:</strong>{' '}
        <a href="https://honeyguideapps.com/partners/press-center">
          https://honeyguideapps.com/partners/press-center
        </a>
      </p>
      
      <p>
        {' '}
        <strong>One Last thing</strong>
      </p>
      <p>
        We are surely not alone to realize that Nepal’s trekking industry is going through
        massive changes and I hope we are not alone in believing that it can get better only
        if we listen and understand each other more. As such, to facilitate this
        communication, Khumbu Pasang Lhamu Rural Municipality in collaboration with
        HoneyGuide will organize a Press Trip to Everest in May. We will be extremely
        honored if you could be part of it.
      </p>
      <p>
        Please Sign Up for the Press Trip here:
        <p className="mb-4">
          Ashish Shrestha <br />
          <a href="mailto:honeyhunter@honeyguideapps.com">
            honeyhunter@honeyguideapps.com
          </a>{' '}
          <br />
          +977-9841370673
        </p>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfZq1PkzOUb3EAHXtvQjZkGNrWE_117qxG3zkG1OznLNt7PFw/viewform?embedded=true"
          width="100%"
          height="1259"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Press Center"
        >
          Loading...
        </iframe>
      </p>
    </p>
    {/* <p>Press Kit for Empower the Himalayas</p> */}
  </Page>
);

export default Press;



// WEBPACK FOOTER //
// ./src/screens/Partners/Press.jsx